<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col">
       <h1>Driver</h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      driver: (state) => state.driver.driver
    })
  },
  async created() {
    await this.loadDriverData();
  },
  methods: {
    ...mapActions('driver', ['getDriverDataAction']),
    async loadDriverData() {
      await this.getDriverDataAction();
    }
  },
};
</script>
